import { format } from 'date-fns'
import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export default function useAddGroupsToLearningItems() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async ({
      groupUuids,
      learningItemsAssignments,
    }: {
      groupUuids: string[]
      learningItemsAssignments: {
        uuid: string
        dueDate?: Date
      }[]
    }) => {
      await api.post('course/assign/learning-items-to-groups', {
        groups: groupUuids,
        learning_items: learningItemsAssignments.map(({ uuid, dueDate }) => ({
          uuid,
          due_date: dueDate ? format(dueDate, 'yyyy-MM-dd') : undefined,
        })),
      })

      await Promise.all([invalidate.groups(), invalidate.users()])
    },
  })
}
